import React from "react";

import { ButtonLink } from "../../components/ButtonLink/ButtonLink";

import {
  Container,
  MainTitle,
  SmallTitle,
  Text,
} from "./styles";

export const NotFound = () => {

  return (
    <Container>
      <SmallTitle>404 ОШИБКА</SmallTitle>
      <MainTitle>
          Страница <span>не найдена</span>
      </MainTitle>
      <Text>Такая страница не существует либо она была удалена.</Text>
      <ButtonLink
        isBlack
        toPage="/"
        title="Главная страница"
      />
    </Container>
  );
};

